module.exports = __webpack_public_path__ + "img/IMG-20220420-WA0001.bec7d154.jpg";